import { useCallback } from 'react';
import StoreProductDB from '../../../../../database/wrappers/storeProduct';
import useBasePriceImport from '../../../pdv/product/hooks/useBasePriceImport';

const chunkArray = (list, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < list.length; i += chunkSize) {
    chunks.push(list.slice(i, i + chunkSize));
  }
  return chunks;
};

const useStoreProductPriceImport = ({
  establishmentId,
  storeId,
  products,
  onShowAlert,
}) => {
  const handleSaveRows = useCallback(async (rowsToUpdate) => {
    const storeProductDB = new StoreProductDB(establishmentId, storeId);
    const chunks = chunkArray(rowsToUpdate, 200);

    for (const chunk of chunks) {
      await Promise.all(chunk.map((item) => {
        if (item.storeProdExist) {
          return storeProductDB.update(item.id, { price: item.newPrice });
        }
        return storeProductDB.define(item.id, { price: item.newPrice });
      }));
    }
  }, [establishmentId, storeId]);

  return useBasePriceImport({
    canImport: !!establishmentId && !!storeId,
    products,
    onShowAlert,
    onSaveRows: handleSaveRows,
    messages: {
      saveError: 'Falha ao atualizar preços da loja.',
    },
  });
};

export default useStoreProductPriceImport;